export const CLINIC_INFO = {
  name: "Lakshmi Oral & Dental Health Care",
  tagline: "Where Beautiful Smiles Begin.",
  phone: "+91 94481 78793",
  phoneRaw: "919448178793",
  email: "lakshmidentalayurveda@gmail.com",
  address: "#83/A, Ground Floor, 5th Main, AECS Layout, Sanjaynagar",
  city: "Bangalore 560094",
  hoursAM: "9:30 AM \u2013 2:00 PM",
  hoursPM: "4:30 PM \u2013 9:00 PM",
  days: "Open All 7 Days",
  logo: "https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/42670686-38e3-4b32-8887-fbb27a0974db_file_000000008fa8720ba048c6766a8de628-removebg-preview.png?v=0aa605cf0fc5ee04c19f8562a0553e64",
};

export const WHATSAPP_BOOK_URL = 'https://wa.me/919448178793?text=Hello%20Doctor,%0A%0ANew%20Appointment%0A%0AName:%0APhone:%0AEmail:%0AService:%0ATime:%0AMessage%20%2F%20special%20requirements:';

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Ayurvedalya", path: "/ayurvedalya" },
  { label: "Gallery", path: "/gallery" },
  { label: "Testimonials", path: "/testimonials" },
  { label: "Contact", path: "/contact" },
];

export const SERVICES_PREVIEW = [
  {
    id: 1,
    icon: "ri-hospital-line",
    title: "General Dentistry",
    desc: "Comprehensive checkups, cleanings, fillings and preventive care to keep your smile healthy.",
    color: "from-teal-600 to-teal-400",
  },
  {
    id: 2,
    icon: "ri-sparkling-line",
    title: "Cosmetic Dentistry",
    desc: "Teeth whitening, veneers, bonding and smile makeovers to give you the perfect look.",
    color: "from-orange-600 to-orange-400",
  },
  {
    id: 3,
    icon: "ri-align-justify",
    title: "Orthodontics",
    desc: "Traditional braces and modern clear aligners to straighten teeth at any age.",
    color: "from-teal-700 to-teal-500",
  },
  {
    id: 4,
    icon: "ri-award-line",
    title: "Dental Implants",
    desc: "Permanent tooth replacement solutions that look, feel and function like natural teeth.",
    color: "from-orange-700 to-orange-500",
  },
  {
    id: 5,
    icon: "ri-heart-pulse-line",
    title: "Root Canal Treatment",
    desc: "Painless, precise root canal procedures to save infected teeth and relieve pain.",
    color: "from-teal-600 to-teal-400",
  },
  {
    id: 6,
    icon: "ri-emotion-happy-line",
    title: "Pediatric Dentistry",
    desc: "Gentle, fun-focused dental care specially designed for children of all ages.",
    color: "from-orange-600 to-orange-400",
  },
];

export const STATS = [
  { number: "5000+", label: "Happy Patients" },
  { number: "15+", label: "Years Experience" },
  { number: "10+", label: "Specialists" },
  { number: "98%", label: "Success Rate" },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Priya Sharma",
    treatment: "Teeth Whitening",
    rating: 5,
    text: "Absolutely incredible experience! The team at Lakshmi Dental made me feel so comfortable. My smile has never looked better \u2014 I get compliments every day. Highly recommend to anyone looking for dental care in Bangalore!",
    image: "https://readdy.ai/api/search-image?query=happy%20indian%20woman%20smiling%20portrait%20natural%20light%20white%20background%20professional%20headshot%20warm%20smile%2030s&width=200&height=200&seq=t1&orientation=squarish",
  },
  {
    id: 2,
    name: "Rajan Pillai",
    treatment: "Dental Implant",
    rating: 5,
    text: "I was very nervous about getting an implant, but Dr. Lakshmi and her team were so reassuring. The procedure was completely painless and the result is amazing. You can\'t tell the difference from my natural teeth!",
    image: "https://readdy.ai/api/search-image?query=happy%20indian%20man%20smiling%20portrait%20natural%20light%20white%20background%20professional%20headshot%20warm%20smile%2040s&width=200&height=200&seq=t2&orientation=squarish",
  },
  {
    id: 3,
    name: "Meena Krishnan",
    treatment: "Orthodontics",
    rating: 5,
    text: "My daughter had braces here and the results are stunning. The staff is incredibly patient with kids and the clinic is spotlessly clean. We are so grateful for the transformation in her confidence!",
    image: "https://readdy.ai/api/search-image?query=happy%20indian%20woman%20smiling%20portrait%20natural%20light%20white%20background%20professional%20headshot%20warm%20smile%2050s&width=200&height=200&seq=t3&orientation=squarish",
  },
];

export const SERVICES_FULL = [
  {
    id: 1,
    title: "General & Preventive Dentistry",
    icon: "ri-hospital-line",
    shortDesc: "The foundation of a healthy smile",
    description: "Our comprehensive general dentistry services are designed to maintain your oral health and catch issues early before they become serious problems. We believe in prevention-first dentistry that saves you time, money, and discomfort.",
    features: [
      "Routine dental checkups & cleanings",
      "Dental X-rays & diagnostics",
      "Tooth-colored composite fillings",
      "Dental crowns & bridges",
      "Tooth extractions",
      "Gum disease treatment",
      "Mouth guards & night guards",
    ],
    image: "https://readdy.ai/api/search-image?query=modern%20dental%20clinic%20treatment%20room%20clean%20professional%20equipment%20bright%20white%20teal%20accents%20dentist%20examination%20simple%20background&width=700&height=500&seq=s1&orientation=landscape",
  },
  {
    id: 2,
    title: "Cosmetic Dentistry",
    icon: "ri-sparkling-line",
    shortDesc: "Your dream smile awaits",
    description: "Transform your smile with our wide range of cosmetic dental procedures. Whether you want brighter teeth, a straighter smile, or a complete makeover, our cosmetic dentistry experts will craft a personalized plan just for you.",
    features: [
      "Professional teeth whitening",
      "Porcelain veneers",
      "Dental bonding",
      "Smile makeover design",
      "Gum contouring",
      "Tooth reshaping",
      "Composite veneers",
    ],
    image: "https://readdy.ai/api/search-image?query=beautiful%20bright%20white%20smile%20cosmetic%20dentistry%20result%20professional%20portrait%20clean%20simple%20studio%20background%20radiant%20confident&width=700&height=500&seq=s2&orientation=landscape",
  },
  {
    id: 3,
    title: "Orthodontics",
    icon: "ri-align-justify",
    shortDesc: "Straight teeth at any age",
    description: "Achieve perfectly aligned teeth with our orthodontic solutions. We offer both traditional braces and modern clear aligner options, tailored to suit your lifestyle, budget, and aesthetic preferences.",
    features: [
      "Metal braces (traditional)",
      "Ceramic braces",
      "Clear aligners / Invisalign-style",
      "Retainers & maintenance",
      "Early orthodontic treatment for children",
      "Adult orthodontics",
      "Space maintainers",
    ],
    image: "https://readdy.ai/api/search-image?query=orthodontics%20dental%20braces%20clear%20aligners%20teeth%20straightening%20professional%20clinic%20modern%20equipment%20clean%20white%20background&width=700&height=500&seq=s3&orientation=landscape",
  },
  {
    id: 4,
    title: "Dental Implants",
    icon: "ri-award-line",
    shortDesc: "Permanent, natural-looking replacements",
    description: "Missing teeth can affect your confidence and oral health. Our dental implant solutions provide a permanent, durable, and aesthetically pleasing replacement that blends seamlessly with your natural teeth.",
    features: [
      "Single tooth implants",
      "Multiple tooth implants",
      "Implant-supported dentures",
      "All-on-4 / All-on-6 implants",
      "Bone grafting",
      "Sinus lift procedures",
      "Implant crown placement",
    ],
    image: "https://readdy.ai/api/search-image?query=dental%20implant%20procedure%20modern%20clinic%20professional%20equipment%20titanium%20implant%20tooth%20replacement%20clean%20clinical%20white%20background&width=700&height=500&seq=s4&orientation=landscape",
  },
  {
    id: 5,
    title: "Root Canal Treatment",
    icon: "ri-heart-pulse-line",
    shortDesc: "Save your teeth, relieve your pain",
    description: "Modern root canal treatment is virtually painless and highly effective. Our skilled endodontists use advanced techniques and tools to save your natural tooth and eliminate infection and pain quickly.",
    features: [
      "Single-visit root canal (most cases)",
      "Rotary endodontics for precision",
      "Digital X-ray guided treatment",
      "Post & core placement",
      "Crown fitting after RCT",
      "Re-treatment of failed root canals",
      "Painless injection technique",
    ],
    image: "https://readdy.ai/api/search-image?query=root%20canal%20treatment%20dental%20procedure%20modern%20equipment%20precision%20tools%20professional%20dental%20clinic%20clean%20white%20background&width=700&height=500&seq=s5&orientation=landscape",
  },
  {
    id: 6,
    title: "Pediatric Dentistry",
    icon: "ri-emotion-happy-line",
    shortDesc: "Gentle care for little smiles",
    description: "We create a warm, friendly environment where children feel comfortable and safe during dental visits. Our pediatric specialists are trained to handle children with care, making dental care a positive experience from an early age.",
    features: [
      "First dental visit consultation",
      "Preventive sealants",
      "Fluoride treatments",
      "Cavity fillings for kids",
      "Space maintainers",
      "Habit correction (thumb sucking, etc.)",
      "Early orthodontic screening",
    ],
    image: "https://readdy.ai/api/search-image?query=child%20at%20dentist%20friendly%20pediatric%20dental%20clinic%20bright%20colorful%20happy%20kid%20dental%20chair%20gentle%20dentist%20clean%20background&width=700&height=500&seq=s6&orientation=landscape",
  },
  {
    id: 7,
    title: "Oral Surgery",
    icon: "ri-surgical-mask-line",
    shortDesc: "Expert surgical procedures with care",
    description: "When surgical intervention is needed, our oral surgery team delivers precise, safe procedures in a comfortable setting. We use the latest techniques to minimize discomfort and ensure fast recovery.",
    features: [
      "Wisdom tooth removal",
      "Complex extractions",
      "Jaw surgery",
      "Biopsy of oral lesions",
      "Cyst & tumor removal",
      "Pre-implant surgery",
      "Facial trauma management",
    ],
    image: "https://readdy.ai/api/search-image?query=oral%20surgery%20dental%20clinic%20professional%20surgeon%20sterile%20environment%20modern%20equipment%20clean%20operating%20room%20white%20teal%20background&width=700&height=500&seq=s7&orientation=landscape",
  },
  {
    id: 8,
    title: "Periodontics (Gum Treatment)",
    icon: "ri-plant-line",
    shortDesc: "Healthy gums, healthy smile",
    description: "Healthy gums are the foundation of a healthy smile. Our periodontal treatment options range from deep cleaning to advanced gum surgery, addressing everything from early gingivitis to severe gum disease.",
    features: [
      "Scaling & root planing",
      "Gum disease treatment",
      "Flap surgery",
      "Bone regeneration",
      "Gum grafting",
      "Gingivitis treatment",
      "Periodontal maintenance",
    ],
    image: "https://readdy.ai/api/search-image?query=gum%20treatment%20periodontics%20dental%20clinic%20professional%20care%20clean%20healthy%20teeth%20gums%20modern%20equipment%20white%20background%20teal&width=700&height=500&seq=s8&orientation=landscape",
  },
];

export const TEAM_MEMBERS = [
  {
    id: 1,
    name: "Dr. Lakshmi Patel",
    role: "Chief Dental Officer",
    qualification: "BDS, MDS (Prosthodontics)",
    experience: "15+ years",
    image: "https://readdy.ai/api/search-image?query=professional%20indian%20female%20dentist%20doctor%20white%20coat%20stethoscope%20smiling%20confident%20portrait%20clinic%20background%20warm%20neutral&width=400&height=400&seq=dr1&orientation=squarish",
  },
  {
    id: 2,
    name: "Dr. Suresh Kumar",
    role: "Orthodontist",
    qualification: "BDS, MDS (Orthodontics)",
    experience: "12+ years",
    image: "https://readdy.ai/api/search-image?query=professional%20indian%20male%20dentist%20doctor%20white%20coat%20smiling%20confident%20portrait%20clinic%20background%20warm%20neutral%2040s&width=400&height=400&seq=dr2&orientation=squarish",
  },
  {
    id: 3,
    name: "Dr. Anita Rao",
    role: "Cosmetic Dentist",
    qualification: "BDS, Fellowship in Cosmetics",
    experience: "10+ years",
    image: "https://readdy.ai/api/search-image?query=professional%20indian%20female%20dentist%20doctor%20white%20coat%20smiling%20confident%20portrait%20clinic%20background%20warm%20neutral%2035s&width=400&height=400&seq=dr3&orientation=squarish",
  },
  {
    id: 4,
    name: "Dr. Rajiv Menon",
    role: "Oral Surgeon",
    qualification: "BDS, MDS (Oral Surgery)",
    experience: "11+ years",
    image: "https://readdy.ai/api/search-image?query=professional%20indian%20male%20dentist%20doctor%20white%20coat%20smiling%20confident%20portrait%20clinic%20background%20warm%20neutral%2045s&width=400&height=400&seq=dr4&orientation=squarish",
  },
];

export const VALUES = [
  {
    icon: "ri-shield-star-line",
    title: "Excellence",
    desc: "We hold ourselves to the highest standards in every procedure, using the latest techniques and technology.",
  },
  {
    icon: "ri-heart-2-line",
    title: "Compassion",
    desc: "Every patient deserves to be treated with kindness, empathy, and respect \u2014 always.",
  },
  {
    icon: "ri-lightbulb-flash-line",
    title: "Innovation",
    desc: "We continuously update our knowledge and equipment to offer you the most advanced dental care available.",
  },
  {
    icon: "ri-user-smile-line",
    title: "Patient-First",
    desc: "Your comfort, safety, and satisfaction are at the center of every decision we make.",
  },
];

export const FAQ_LIST = [
  {
    q: "Is root canal treatment painful?",
    a: "Modern root canal treatment is virtually painless. We use advanced anesthesia techniques and rotary endodontics to ensure a comfortable, pain-free experience. Most patients are surprised at how easy the procedure is.",
  },
  {
    q: "How often should I visit the dentist?",
    a: "We recommend a dental checkup and cleaning every 6 months for most patients. If you have specific concerns like gum disease or active cavities, more frequent visits may be recommended.",
  },
  {
    q: "Do you offer EMI / payment plans?",
    a: "Yes, we offer flexible payment options including EMI plans for major treatments like implants and orthodontics. Please ask our front desk team for details during your consultation.",
  },
  {
    q: "What age should children start seeing a dentist?",
    a: "We recommend bringing your child in for their first dental visit when their first tooth appears, or by their first birthday \u2014 whichever comes first. Early visits help establish good dental habits.",
  },
  {
    q: "How long does teeth whitening take?",
    a: "Professional in-office teeth whitening typically takes about 60-90 minutes and can lighten your teeth by several shades in a single visit. Results last 1-3 years with proper care.",
  },
  {
    q: "Do you provide emergency dental services?",
    a: "Yes, we handle dental emergencies. If you are experiencing severe tooth pain, a broken tooth, or dental injury, please call us immediately at +91 94481 78793.",
  },
  {
    q: "How long does a dental implant procedure take?",
    a: "The implant process typically takes 3-6 months from start to finish. The implant is placed first, then allowed to integrate with the bone before the crown is attached. Some cases may qualify for same-day implants.",
  },
  {
    q: "Are your sterilization procedures safe?",
    a: "Absolutely. We follow strict sterilization and infection control protocols that exceed standard healthcare guidelines. All instruments are sterilized in an autoclave after each use.",
  },
];

export const DENTAL_SERVICES = [
  {
    id: 1,
    icon: 'ri-hospital-line',
    title: 'General Dentistry',
    tag: 'Preventive Care',
    desc: 'Complete oral health checkups and preventive care to keep your smile healthy all year round.',
    cardImage: 'https://static.readdy.ai/image/72ebb3450643617b8a5b38c5c017e687/426f3322eb8b9138f008a0261f1f1cfe.jpeg',
    bullets: ['Dental Check-up & Cleaning', 'Tooth Fillings', 'Pain Treatment', 'Preventive Care', 'Bad Breath Treatment'],
    slug: 'general-dentistry',
  },
  {
    id: 2,
    icon: 'ri-sparkling-2-line',
    title: 'Cosmetic Dentistry',
    tag: 'Smile Enhancement',
    desc: 'Teeth whitening, veneers, bonding and smile makeovers to give you the perfect radiant look.',
    cardImage: 'https://static.readdy.ai/image/72ebb3450643617b8a5b38c5c017e687/1e395d292480630444ce635a8194f24b.jpeg',
    bullets: ['Teeth Whitening', 'Smile Designing', 'Teeth Reshaping', 'Dental Bonding', 'Gap Closing', 'Tooth Jewellery'],
    slug: 'cosmetic-dentistry',
  },
  {
    id: 3,
    icon: 'ri-heart-pulse-line',
    title: 'Root Canal Treatment',
    tag: 'Endodontics',
    desc: 'Painless, precise root canal procedures to save your natural tooth and relieve pain.',
    cardImage: 'https://static.readdy.ai/image/72ebb3450643617b8a5b38c5c017e687/e42e66df463052226acb3a6ddb346994.jpeg',
    bullets: ['Root Canal Therapy (RCT)', 'Endodontic Treatment', 'Biomimetic Dentistry', 'Tooth Restoration'],
    slug: 'root-canal-treatment',
  },
  {
    id: 4,
    icon: 'ri-empathize-line',
    title: 'Tooth Replacement',
    tag: 'Prosthodontics',
    desc: 'Crowns, bridges, dentures and more — restoring function and aesthetics beautifully.',
    cardImage: 'https://static.readdy.ai/image/72ebb3450643617b8a5b38c5c017e687/570a77f766f7926b027af2b746b03345.jpeg',
    bullets: ['Dental Crowns', 'Bridges', 'Partial Dentures', 'Complete Dentures', 'BPS Dentures', 'Fixed Prosthodontics'],
    slug: 'tooth-replacement',
  },
  {
    id: 5,
    icon: 'ri-align-center',
    title: 'Orthodontics & Braces',
    tag: 'Teeth Alignment',
    desc: 'Traditional braces and modern clear aligners to straighten your smile at any age.',
    cardImage: 'https://static.readdy.ai/image/72ebb3450643617b8a5b38c5c017e687/592561227ae611ef119db22d113c5a10.jpeg',
    bullets: ['Metal Braces', 'Ceramic Braces', 'Lingual Braces', 'Invisalign', 'Teeth Alignment'],
    slug: 'orthodontics-braces',
  },
  {
    id: 6,
    icon: 'ri-award-line',
    title: 'Dental Implants',
    tag: 'Permanent Replacement',
    desc: 'Permanent, natural-looking tooth replacements that feel and function like real teeth.',
    cardImage: 'https://static.readdy.ai/image/72ebb3450643617b8a5b38c5c017e687/e66b8adff2d4c494ace3e932f63cf301.jpeg',
    bullets: ['Single Tooth Implant', 'Multiple Implants', 'Full Mouth Implants', 'Implant Supported Dentures'],
    slug: 'dental-implants',
  },
  {
    id: 7,
    icon: 'ri-surgical-mask-line',
    title: 'Oral Surgery',
    tag: 'Surgical Procedures',
    desc: 'Safe, precise oral surgical procedures performed by experienced specialist surgeons.',
    cardImage: 'https://static.readdy.ai/image/72ebb3450643617b8a5b38c5c017e687/12b64f95cf285dc7db7c07ad4b8a974b.jpeg',
    bullets: ['Tooth Extraction', 'Surgical Removal', 'Wisdom Tooth Removal', 'Minor Oral Surgeries', 'Maxillofacial Surgery'],
    slug: 'oral-surgery',
  },
  {
    id: 8,
    icon: 'ri-plant-line',
    title: 'Gum Treatment',
    tag: 'Periodontics',
    desc: 'Complete periodontal care from scaling and root planing to advanced gum surgery.',
    cardImage: 'https://static.readdy.ai/image/72ebb3450643617b8a5b38c5c017e687/bd6df1e5c99f5c38b7831983553571dc.jpeg',
    bullets: ['Gum Disease Treatment', 'Flap Surgery', 'Periodontal Therapy', 'Bleeding Gums Treatment', 'TMJ Treatment'],
    slug: 'gum-treatment',
  },
  {
    id: 9,
    icon: 'ri-emotion-happy-line',
    title: 'Pediatric Dentistry',
    tag: "Children's Care",
    desc: 'Gentle, fun-focused dental care specially designed for children of all ages.',
    cardImage: 'https://static.readdy.ai/image/72ebb3450643617b8a5b38c5c017e687/e9a35d061461f404f800dc04c48aeb1f.jpeg',
    bullets: ["Children's Check-ups", 'Preventive Kids Care', 'Pediatric Treatments'],
    slug: 'pediatric-dentistry',
  },
  {
    id: 10,
    icon: 'ri-scan-line',
    title: 'Advanced Dental Services',
    tag: 'Modern Technology',
    desc: 'Laser dentistry, 3D scanning and cutting-edge digital technology for precision care.',
    cardImage: 'https://static.readdy.ai/image/72ebb3450643617b8a5b38c5c017e687/1c0918cbab50d4daf5ffb9cc9afa3f2e.jpeg',
    bullets: ['Laser Dentistry', '3D Intraoral Digital Scanning', 'Zirconia Metal-Free Crowns', '3D Printed Crowns', 'Sedation Dentistry'],
    slug: 'advanced-dental-services',
  },
];

export const HOME_STATS = [
  { number: 24, suffix: "+", label: "Years of Excellence" },
  { number: 5000, suffix: "+", label: "Happy Patients" },
  { number: 10, suffix: "+", label: "Specializations" },
  { number: 7, suffix: "", label: "Days Always Open" },
];

export const HOME_SERVICES = [
  {
    id: 1,
    icon: "ri-hospital-line",
    title: "General Dentistry",
    desc: "Complete oral health checkups and preventive care",
  },
  {
    id: 2,
    icon: "ri-sparkling-2-line",
    title: "Cosmetic Dentistry",
    desc: "Enhance your smile with advanced cosmetic solutions",
  },
  {
    id: 3,
    icon: "ri-heart-pulse-line",
    title: "Root Canal Treatment",
    desc: "Painless and precise endodontic therapy",
  },
  {
    id: 4,
    icon: "ri-empathize-line",
    title: "Tooth Replacement",
    desc: "Crowns, bridges, dentures and more",
  },
  {
    id: 5,
    icon: "ri-align-center",
    title: "Orthodontics & Braces",
    desc: "Straighten your teeth with modern braces",
  },
  {
    id: 6,
    icon: "ri-award-line",
    title: "Dental Implants",
    desc: "Permanent natural-looking tooth replacement",
  },
  {
    id: 7,
    icon: "ri-surgical-mask-line",
    title: "Oral Surgery",
    desc: "Safe and precise surgical dental procedures",
  },
  {
    id: 8,
    icon: "ri-plant-line",
    title: "Gum Treatment",
    desc: "Complete periodontal care and gum health",
  },
  {
    id: 9,
    icon: "ri-emotion-happy-line",
    title: "Pediatric Dentistry",
    desc: "Gentle and fun dental care for children",
  },
  {
    id: 10,
    icon: "ri-scan-line",
    title: "Advanced Dental Services",
    desc: "Laser, 3D scanning & cutting-edge technology",
  },
];

export const FEATURED_REVIEW = {
  id: 0,
  name: 'Ashok Kumar',
  treatment: 'General Dentistry + Dental Caps',
  rating: 5,
  review:
    "An exceptional dental experience at Sanjaynagar's finest clinic! My elderly mother was suffering from severe pain and swelling in her upper teeth. Dr. Yogesh diagnosed the condition with great precision and treated her with a combination of careful tooth removal and root canal treatments. He then restored her smile beautifully with perfectly crafted artificial dental caps. His expertise, patience, and compassionate care throughout the entire process was truly remarkable. We are so grateful and highly recommend Dr. Yogesh to anyone looking for expert dental care in Bangalore!",
  initial: 'A',
  initials: 'A',
  avatarColor: 'bg-[#8B6914]',
  color: 'bg-[#8B6914]',
  googleLink: 'https://goo.gl/maps/1fma6q6XvAiTjtu88',
};

export const ALL_REVIEWS = [
  {
    id: 1,
    name: 'Vanitha',
    rating: 5,
    review: 'Excellent care and treatment. The doctor handled everything with patience and professionalism. I felt comfortable throughout the process and highly recommend this clinic.',
    initial: 'V',
    initials: 'V',
    avatarColor: 'bg-[#8B6914]',
    color: 'bg-[#8B6914]',
    googleLink: 'https://goo.gl/maps/ZRnHzzNeB5Jxd722A',
  },
  {
    id: 2,
    name: 'Venu Venu',
    rating: 5,
    review: 'It was Sunday, and Dr. Yogesh came and helped me with my unbearable tooth pain. Now I feel comfortable and truly appreciate his treatment. He saved one of my teeth and removed my wisdom tooth. Thank you, doctor.',
    initial: 'VV',
    initials: 'VV',
    avatarColor: 'bg-[#D4900A]',
    color: 'bg-[#D4900A]',
    googleLink: 'https://goo.gl/maps/QswL7G18xyC1tTrj6',
  },
  {
    id: 3,
    name: 'Karan Aneja',
    rating: 5,
    review: 'I had a very good experience with the doctor. They explained everything in detail and provided excellent treatment for tooth removal, RCT, and excision. I felt well-informed and well cared for throughout the process.',
    initial: 'KA',
    initials: 'KA',
    avatarColor: 'bg-[#8B6914]',
    color: 'bg-[#8B6914]',
    googleLink: 'https://goo.gl/maps/ucB93wHmTpXdjM696',
  },
  {
    id: 4,
    name: 'Thomaskutty Alex',
    rating: 5,
    review: 'The treatment was excellent and time management was good. I was treated by both the specialist and Dr. Yogesh. The clinic has a great ambience. I highly recommend it for painless and effective procedures.',
    initial: 'TA',
    initials: 'TA',
    avatarColor: 'bg-[#D4900A]',
    color: 'bg-[#D4900A]',
    googleLink: 'https://goo.gl/maps/9e3A56UiUHZ4FNrt9',
  },
  {
    id: 5,
    name: 'Sk Nuralam',
    rating: 5,
    review: 'The doctor saved my teeth. I am from Kolkata, and the assistant explained everything clearly after Dr. Yogesh\'s consultation. Now my teeth look good and I have no pain. The doctor was kind and even helped with my final bill.',
    initial: 'SN',
    initials: 'SN',
    avatarColor: 'bg-[#8B6914]',
    color: 'bg-[#8B6914]',
    googleLink: 'https://goo.gl/maps/ePyCzrj7aGomk7D79',
  },
  {
    id: 6,
    name: 'Mahesh',
    rating: 5,
    review: 'My daughter had two teeth growing one behind another. She was diagnosed properly and the extra tooth was removed at the right time. My younger daughter had stubborn stains, and Dr. Yogesh treated her with cleaning and medication. Now she is doing much better.',
    initial: 'M',
    initials: 'M',
    avatarColor: 'bg-[#D4900A]',
    color: 'bg-[#D4900A]',
    googleLink: 'https://goo.gl/maps/fipLw41dmmTaNn6P6',
  },
  {
    id: 7,
    name: 'Pavana H S',
    rating: 5,
    review: 'I had a good experience with Dr. Yogesh. I was scared of dental treatment, but he handled everything very calmly and carefully. My food lodgement problem is gone now after RCT and filling. I feel comfortable now.',
    initial: 'PH',
    initials: 'PH',
    avatarColor: 'bg-[#8B6914]',
    color: 'bg-[#8B6914]',
    googleLink: 'https://goo.gl/maps/fxeyAv12nRJAPyTb7',
  },
  {
    id: 8,
    name: 'Thaya Shankaree Karthikeyan',
    rating: 5,
    review: 'I would like to thank Dr. Yogesh for making my RCT painless. He treats patients with great patience and care. A very dedicated doctor. Thank you so much, sir.',
    initial: 'TK',
    initials: 'TK',
    avatarColor: 'bg-[#D4900A]',
    color: 'bg-[#D4900A]',
    googleLink: 'https://goo.gl/maps/6zxnD35hW36FpYAy5',
  },
  {
    id: 9,
    name: 'Varalakshmi Srinivas M',
    rating: 5,
    review: 'Thank you so much. It was a very good experience with great ambience. The assistant doctor was also helpful. Dr. Yogesh provided excellent treatment and explained everything clearly. The entire process was transparent and smooth.',
    initial: 'VS',
    initials: 'VS',
    avatarColor: 'bg-[#8B6914]',
    color: 'bg-[#8B6914]',
    googleLink: 'https://goo.gl/maps/oxi4g4bnzsmZTt3n7',
  },
  {
    id: 10,
    name: 'Prathiksha Ghodke',
    rating: 5,
    review: 'Dr. Yogesh fixed my missing tooth with an implant and matched the cap perfectly before my wedding. My smile looks beautiful now. He also cleaned and polished my teeth, making them much whiter. Great job by Dr. Yogesh.',
    initial: 'PG',
    initials: 'PG',
    avatarColor: 'bg-[#D4900A]',
    color: 'bg-[#D4900A]',
    googleLink: 'https://goo.gl/maps/dkk4rnE2pxhXq3LP7',
  },
  {
    id: 11,
    name: 'Raj Peddavali',
    rating: 5,
    review: 'The doctor was kind enough to understand my situation and treated my teeth properly. I am now comfortable, and my replacement with a fixed bridge is done well. I can smile again without pain.',
    initial: 'RP',
    initials: 'RP',
    avatarColor: 'bg-[#8B6914]',
    color: 'bg-[#8B6914]',
    googleLink: 'https://goo.gl/maps/12GbzFM6VMh1DKxdA',
  },
];

// Keep backward compat alias
export const HOME_TESTIMONIALS = ALL_REVIEWS;

// Only real client-uploaded photos
export const GALLERY_IMAGES = [
  {
    id: 1,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/99dc15b4-3a7c-4244-ad3b-e05c07659f85_WhatsApp-Image-2026-03-24-at-1.01.08-PM-1.jpeg?v=381d397e70799a632b9e0d6c09a70206',
    alt: 'Clinic Photo',
    height: 'h-64',
  },
  {
    id: 2,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/7ba2a71a-e4c0-4b8d-92f0-aa8a8eecd444_20260314_181251.jpg.jpeg?v=18c4970506bdd6690915aa827f801f74',
    alt: 'Our Clinic',
    height: 'h-72',
  },
  {
    id: 3,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/6c59b103-f13c-4f67-ad1c-479aabab5efd_WhatsApp-Image-2026-03-24-at-1.01.07-PM-1.jpeg?v=ee90a52d7cb9cd05310f6473f51b7537',
    alt: 'Treatment Room',
    height: 'h-56',
  },
  {
    id: 4,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/54b515df-da20-48c9-9346-49bcfa554d06_WhatsApp-Image-2026-03-24-at-1.01.07-PM.jpeg?v=c9a44a959f50beb6492d087a8abd933e',
    alt: 'Dental Care',
    height: 'h-64',
  },
  {
    id: 5,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/aa203f16-7d08-4e03-8e16-2bca433e8155_WhatsApp-Image-2026-03-24-at-1.01.06-PM-1.jpeg?v=6998838f6e5484e458df0172c0072f06',
    alt: 'Clinic Interior',
    height: 'h-52',
  },
  {
    id: 6,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/6d8fdce6-0231-40ec-a5dd-fc4923422627_WhatsApp-Image-2026-03-24-at-1.01.06-PM.jpeg?v=730bd72a2c47b21299500ee863ac2d42',
    alt: 'Our Team',
    height: 'h-64',
  },
];

// Only real client-uploaded photos
export const GALLERY_FULL = [
  {
    id: 101,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/f514314e-fbe9-4660-8626-16f1da7ad518_IMG-20260314-WA0037.jpg?v=bb49ae0b6bb8bc6a800cc6b538e43716',
    alt: 'Our Team',
    caption: 'Our dedicated dental team at Lakshmi Oral & Dental Health Care',
    category: 'Team & Staff',
  },
  {
    id: 102,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/8634b388-87ae-4d0a-8224-be217f2c522f_20260314_181251.jpg?v=18c4970506bdd6690915aa827f801f74',
    alt: 'Clinic Interior',
    caption: 'Inside our modern clinic — clean, calm, and welcoming',
    category: 'Clinic Interior',
  },
  {
    id: 103,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/d67dba72-a04b-4822-8127-90f5c1b76d26_IMG-20260324-WA0032.jpg?v=b8f2d8c2919131103c1258e3422feff9',
    alt: 'Patient Care',
    caption: 'Compassionate patient care at every step of your treatment',
    category: 'Treatments',
  },
  {
    id: 104,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/67342864-6b4b-4bca-9abf-5dbe67b1b9c0_IMG-20260324-WA0027.jpg?v=9bdf2dc18b87e953fd88766c57b1f846',
    alt: 'Dental Treatment',
    caption: 'Expert dental procedures in a state-of-the-art environment',
    category: 'Treatments',
  },
  {
    id: 1,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/7ba2a71a-e4c0-4b8d-92f0-aa8a8eecd444_20260314_181251.jpg.jpeg?v=18c4970506bdd6690915aa827f801f74',
    alt: 'Clinic Photo',
    caption: 'Inside our modern clinic at Lakshmi Oral & Dental Health Care',
    category: 'Clinic Interior',
  },
  {
    id: 2,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/343b19ca-d9a7-43c0-87ce-715677b11c83_WhatsApp-Image-2026-03-24-at-1.01.05-PM---Copy.jpeg?v=1282b7aaa4edc19fe655590d53b190e1',
    alt: 'Clinic Interior',
    caption: 'Our clinic environment — clean, modern, and welcoming',
    category: 'Clinic Interior',
  },
  {
    id: 3,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/0c8c8d9f-0785-44be-9f6a-22ac3e5cfbef_WhatsApp-Image-2026-03-24-at-1.01.05-PM.jpeg?v=1282b7aaa4edc19fe655590d53b190e1',
    alt: 'Dental Treatment',
    caption: 'Advanced dental treatment with our specialist team',
    category: 'Treatments',
  },
  {
    id: 4,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/c5f3935c-b2fe-411d-9bae-1bed9c847d87_WhatsApp-Image-2026-03-24-at-1.01.04-PM-1.jpeg?v=7f11b03394a06b0a646bcfac2bef02fb',
    alt: 'Clinic Visit',
    caption: 'Personalized dental care at every visit',
    category: 'Treatments',
  },
  {
    id: 5,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/9009814d-278d-4275-b170-324dd71b2f14_WhatsApp-Image-2026-03-24-at-1.01.04-PM.jpeg?v=1e15e3cabec6bc57cb4e12031a7b5b08',
    alt: 'Our Clinic',
    caption: 'A warm and professional space dedicated to your dental health',
    category: 'Clinic Interior',
  },
  {
    id: 6,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/f4d61ab5-e84e-4303-a25e-24a6c177769e_IMG-20260314-WA0037.jpg.jpeg?v=bb49ae0b6bb8bc6a800cc6b538e43716',
    alt: 'Our Team',
    caption: 'Our dedicated dental team — here to serve you with care',
    category: 'Team & Staff',
  },
  {
    id: 7,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/b4ba1da3-7c75-4256-b736-8d2fddaed183_WhatsApp-Image-2026-03-24-at-1.01.03-PM.jpeg?v=c4c19f3e1e0cd82dab07c8c106a44944',
    alt: 'Team & Care',
    caption: 'Compassionate care by our experienced dental professionals',
    category: 'Team & Staff',
  },
  {
    id: 8,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/99dc15b4-3a7c-4244-ad3b-e05c07659f85_WhatsApp-Image-2026-03-24-at-1.01.08-PM-1.jpeg?v=381d397e70799a632b9e0d6c09a70206',
    alt: 'Clinic Facility',
    caption: 'State-of-the-art facilities at Lakshmi Oral & Dental Health Care',
    category: 'Clinic Interior',
  },
  {
    id: 9,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/6c59b103-f13c-4f67-ad1c-479aabab5efd_WhatsApp-Image-2026-03-24-at-1.01.07-PM-1.jpeg?v=ee90a52d7cb9cd05310f6473f51b7537',
    alt: 'Treatment Area',
    caption: 'Our modern treatment area equipped with latest dental technology',
    category: 'Treatments',
  },
  {
    id: 10,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/54b515df-da20-48c9-9346-49bcfa554d06_WhatsApp-Image-2026-03-24-at-1.01.07-PM.jpeg?v=c9a44a959f50beb6492d087a8abd933e',
    alt: 'Dental Clinic',
    caption: 'Professional dental care in a comfortable environment',
    category: 'Clinic Interior',
  },
  {
    id: 11,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/aa203f16-7d08-4e03-8e16-2bca433e8155_WhatsApp-Image-2026-03-24-at-1.01.06-PM-1.jpeg?v=6998838f6e5484e458df0172c0072f06',
    alt: 'Patient Care',
    caption: 'Dedicated patient care with a personal touch',
    category: 'Treatments',
  },
  {
    id: 12,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/6d8fdce6-0231-40ec-a5dd-fc4923422627_WhatsApp-Image-2026-03-24-at-1.01.06-PM.jpeg?v=730bd72a2c47b21299500ee863ac2d42',
    alt: 'Clinic Staff',
    caption: 'Our friendly and skilled dental staff ready to serve you',
    category: 'Team & Staff',
  },
  {
    id: 13,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/e8c7faec-faa2-4117-a015-fa09126afce2_WhatsApp-Image-2026-03-24-at-1.01.05-PM-2.jpeg?v=20fa51738200020129e83b8f39b0255a',
    alt: 'Dental Procedure',
    caption: 'Precise and gentle dental procedures for every patient',
    category: 'Treatments',
  },
  {
    id: 14,
    src: 'https://storage.readdy-site.link/project_files/c4893f46-78a8-468c-a94c-da841665c127/744c9d0d-6795-4b16-9f34-0e8449fa0613_WhatsApp-Image-2026-03-24-at-1.01.05-PM-1---Copy.jpeg?v=278d560a7170926d82678b9487c8e78a',
    alt: 'Clinic Overview',
    caption: 'A comprehensive dental care experience at Lakshmi Dental',
    category: 'Clinic Interior',
  },
];
